module.exports = __webpack_public_path__ + "static/media/test16.bf2d6177.jpeg";